import React, { useState } from "react";
import cx from "classnames";
import ReactTable from "react-table";
import { Input } from "reactstrap";
import Select from "react-select";
import {
  Table as ResponsiveTable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from "react-super-responsive-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { CSVLink } from "react-csv";

import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const Filters = ({ columns, onChange }) => {
  return (
    <Select
      className="mb-2"
      options={columns
        .filter(c => typeof c.accessor === "string" && c.filterable !== false)
        .map(col => ({
          label: col.Header,
          value: col.accessor
        }))}
      placeholder="Selecteza coloana de filtru..."
      noOptionsMessage={() => "Niciun filtru disponibil"}
      onChange={onChange}
    />
  );
};

const Table = ({
  className,
  exportCSV,
  exportFunction,
  exportFileName,
  columns,
  data,
  onFilterMobileTable,
  ...rest
}) => {
  const [mobileFilter, setMobileFilter] = useState({});

  const filterMethod = (filter, row) => {
    row[filter.id] += "";

    if (filter.id === "status") {
      return String(row[filter.id].toUpperCase()).startsWith(
        filter.value.toUpperCase()
      );
    }
    return String(row[filter.id].toUpperCase()).includes(
      filter.value.toUpperCase()
    );
  };


  return (
    <div className="table__container w-100">
      {exportCSV && (
        <div className="w-100 d-flex flex-row-reverse">
          <CSVLink filename={`${exportFileName}.csv`} data={exportFunction(data)}>
            <Button style={{ fontWeight: "bold" }} className="mb-3 fifth">
               <FontAwesomeIcon icon={faFileCsv} style={{fontSize: "1.6rem"}} />
            </Button>
          </CSVLink>
        </div>
      )}
      <ReactTable
        className={cx("-highlight -striped", className)}
        defaultFilterMethod={filterMethod}
        filterable
        {...rest}
        ofText="din"
        rowsText="randuri"
        pageText="Pagina"
        previousText="Inapoi"
        nextText="Inainte"
        resizable={false}
        pageSizeOptions={[5, 10, 25, 50]}
        columns={columns}
        data={data}
      />
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  exportCSV: PropTypes.bool,
  exportFunction: PropTypes.func
};

Table.defaultProps = {
  columns: [],
  data: [],
  exportCSV: false,
  exportFunction: (data = []) => {
    return data;
  },
  exportFileName: "export",
  noDataText: "Nu exista date",
  defaultPageSize: 25
};

export default Table;
